// GA4 destination for this build; independent of API/environment configuration.
export const analytics = {
  enabled: true,
  measurementId: 'G-ZP8WNBR75R',
  productId: 'school_program',
  appVariant: 'default',
  environment: 'dev',
};
